import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/commerce/shipments")({
	component: () => <Outlet />,
});
